import classNames from "classnames/bind";
import React from "react";
import Breadcrumb from "./Breadcrumb";
import styles from "./Breadcrumbs.module.scss";
import CollapsibleBreadcrumbs from "./CollapsibleBreadcrumbs";
import type { BreadcrumbsProps } from "./types";

const cx = classNames.bind(styles);

const NUM_OF_COLLAPSE_BREADCRUMB_LIMIT = 4;
const NUM_OF_BREADCRUMB_TO_SHOW = 2;

/**
 * A component for showing where a user is currently in the website's hierarchy
 */
const Breadcrumbs = ({
  breadcrumbs = [],
  isLoading = false,
}: BreadcrumbsProps) => {
  const lastBreadcrumbIndex = breadcrumbs.length - 1;
  // We will only show the first and last two of the breadcrumb element and
  // we will collapsed the rest
  const startOfCollapsedBreadcrumbIndex = NUM_OF_BREADCRUMB_TO_SHOW;
  const endOfCollapsedBreadcrumbIndex =
    breadcrumbs.length - NUM_OF_BREADCRUMB_TO_SHOW;

  return (
    <nav
      role="breadcrumbs"
      className={cx("container")}
      aria-label="breadcrumbs"
    >
      <ol className={cx("breadcrumbs")}>
        {breadcrumbs.map(({ title, ...restProps }, index) => {
          const sharedProps = {
            isLoading,
            isLastBreadcrumb: index === lastBreadcrumbIndex,
          };

          // We will show the first two breadcrumbs
          if (index < startOfCollapsedBreadcrumbIndex) {
            return (
              <Breadcrumb
                key={`${title}-${index}`}
                title={title}
                {...restProps}
                {...sharedProps}
              />
            );
          }

          // We will hide any breadcrumb in between the limits
          if (
            breadcrumbs.length > NUM_OF_COLLAPSE_BREADCRUMB_LIMIT &&
            index === startOfCollapsedBreadcrumbIndex
          ) {
            return (
              <CollapsibleBreadcrumbs
                key={title}
                breadcrumbs={breadcrumbs.slice(
                  index,
                  endOfCollapsedBreadcrumbIndex
                )}
                {...sharedProps}
              />
            );
          }

          if (index >= endOfCollapsedBreadcrumbIndex) {
            return (
              <Breadcrumb
                key={title}
                title={title}
                {...restProps}
                {...sharedProps}
              />
            );
          }

          return null;
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
